import { useEffect, useMemo, useState } from "react";

type Options = Readonly<{
  intervalMs?: number;
}>;

export function useDynamicLoader(
  messages: readonly string[],
  isActive: boolean,
  options: Options = {},
): string {
  const intervalMs = options.intervalMs ?? 1200;

  const safeMessages = useMemo(() => (messages.length ? messages : ["Loading..."]), [messages]);

  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!isActive) {
      setIndex(0);
      return;
    }

    const id = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % safeMessages.length);
    }, intervalMs);

    return () => window.clearInterval(id);
  }, [isActive, intervalMs, safeMessages.length]);

  return safeMessages[index] ?? "Loading...";
}
